export const manifest = {
  screens: {
    scr_3zmilw: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_kypd23: { name: "Commercial & Business Lawyers", route: "/services/commercial-business-law", position: {"x":1560,"y":220} },
    scr_1a99kx: { name: "Family Law", route: "/services/family-law", position: {"x":2960,"y":220} },
    scr_ra2xfw: { name: "Make an Enquiry", route: "/enquiry", position: {"x":160,"y":2200} },
  },
  sections: {
    sec_wattf6: { name: "Services & Navigation", x: 0, y: 0, width: 4320, height: 1180 },
    sec_h43ip6: { name: "Enquiry Flow", x: 0, y: 1980, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_wattf6", children: [
      { kind: "screen", id: "scr_3zmilw" },
      { kind: "screen", id: "scr_kypd23" },
      { kind: "screen", id: "scr_1a99kx" },
    ] },
    { kind: "section", id: "sec_h43ip6", children: [
      { kind: "screen", id: "scr_ra2xfw" },
    ] },
  ],
}
